import { Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem("access");
  const isAdmin = localStorage.getItem("is_superuser");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (isAdmin !== "true") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;